import {CloseSvg} from '@/icons';
import styles from './index.module.scss';
import Icon, {IconSize} from '@/components/Icon';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import {useEffect, useRef, useState} from 'react';
import {Popper} from '@baidu/luffy-comp-popper';
import {showCardLikeNewGuidLog} from '@/buried/docCard';
import {throttle} from 'lodash-es';

interface INewGuid {
    // children: React.ReactNode;
    // show: boolean;
    getTarget: () => HTMLElement;
    onCloseNewGuid: () => void;
}

function NewGuid({
    // show,
    // blockId,
    getTarget,
    onCloseNewGuid,
}: INewGuid) {
    const tipContentRef = useRef<HTMLDivElement>(null);
    const portalContainer = useRef(document.querySelector('.baidu__editor__content'));
    const [updateOption, setUpdateOption] = useState<number>(1);

    // pm又不要这个消失逻辑了，先注释
    // const {setShouldObserve} = useIntersectionObserver(tipContentRef.current as HTMLElement, {
    //     failCallback() {
    //         // 当dom不在可视区域内，关闭新手引导
    //         onCloseNewGuid();
    //         setShouldObserve(false);
    //     },
    // });

    // useEffect(() => {
    //     setShouldObserve(true);
    // }, [setShouldObserve]);


    useEffect(() => {
        showCardLikeNewGuidLog();
    }, []);

    useEffect(() => {
        function handleResize() {
            setUpdateOption(Date.now());
        }
        const onResizeThrottle = throttle(handleResize, 150);
        let resizeObserver: ResizeObserver | null = null;
        if (window.ResizeObserver && portalContainer.current) {
            resizeObserver = new window.ResizeObserver(() => {
                onResizeThrottle();
            });

            resizeObserver.observe(portalContainer.current);
        }

        return () => {
            resizeObserver && resizeObserver.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleClose() {
        onCloseNewGuid();
    }

    // return <>
    //     {children}
    //     {
    //         show
    //         && <div ref={tipContentRef} className={styles.tipContent} id={'cardLike_NewGuid'}>
    //             卡片支持点赞了，给你觉得精彩的部分点赞吧！
    //             <Icon className={styles.closeSvg} svg={CloseSvg} size={IconSize.XS} />
    //         </div>
    //     }
    // </>;

    return <Popper
        // 虽然popper组件eventsEnabled可以监听scroll和resize，更新popper位置，但是业务场景下一些操作导致编辑器卡片宽度变化，这种覆盖不到
        // 因此，监听下编辑器dom容器resize，通过更新key更新popper
        key={updateOption}
        className={styles.popperWrap}
        placement={'bottom-end'}
        withArrow
        visible
        defaultVisible
        eventsEnabled
        destroyOnHide={false}
        target={getTarget()}
        portalContainer={portalContainer.current}
    >
        <div className={styles.tipContent} ref={tipContentRef}>
            卡片支持点赞了，给你觉得精彩的部分点赞吧！
            <Icon onClick={handleClose} className={styles.closeSvg} svg={CloseSvg} size={IconSize.XS} />
        </div>
    </Popper>;
}

export default NewGuid;
